import { LoginOptionsResponse, Convert as LoginOptionsResponseConvert } from 'models/schema-generated-models/api-response-bodies/login-options-response';
import { LoginOptionsRequest } from 'models/schema-generated-models/requests/auth-configs/login-options-request';
import { SSOAPIContextParser } from 'services/api-context-service/sso-api-context-parser';
import {
    SSOAPINotFoundError,
    SSOAPIUnexpectedResponseBody
} from 'services/errors';
import { BaseService } from 'services/sso-api/base-service';
import { ClientResponse } from '../client/client-response';

export enum LoginOptionsRoute {
    ALL_AUTH_OPTIONS = '/auth-configs/all-auth-options'
}

export class LoginOptionsService extends BaseService {
    private async processApiResponse(response: ClientResponse): Promise<LoginOptionsResponse> {
        const body = await response.text();
        const responseAPIContext = SSOAPIContextParser.getSSOAPIContextFromResponse(response);

        if (response.status === 200) {
            try {
                return LoginOptionsResponseConvert.toLoginOptionsResponse(body);
            } catch (err) {
                throw new SSOAPIUnexpectedResponseBody(responseAPIContext, 'Unexpected response body received.', { cause: err as Error });
            }
        }

        if (response.status === 404) {
            throw new SSOAPINotFoundError(responseAPIContext);
        }

        throw this.processGeneralAPIError(response, body, responseAPIContext);
    }

    getLoginOptions = async (): Promise<LoginOptionsResponse> => {
        const response: ClientResponse = await this.client.get(LoginOptionsRoute.ALL_AUTH_OPTIONS);
        return this.processApiResponse(response);
    };

    postLoginOptions = async (loginOptions: LoginOptionsRequest): Promise<LoginOptionsResponse> => {
        const response: ClientResponse = await this.client.post(LoginOptionsRoute.ALL_AUTH_OPTIONS, { body: JSON.stringify(loginOptions) });
        return this.processApiResponse(response);
    };

    putLoginOptions = async (loginOptions: Partial<LoginOptionsRequest>): Promise<LoginOptionsResponse> => {
        const response: ClientResponse = await this.client.put(LoginOptionsRoute.ALL_AUTH_OPTIONS, { body: JSON.stringify(loginOptions) });
        return this.processApiResponse(response);
    };
}
